// extracted by mini-css-extract-plugin
module.exports = {"InfoContainer":"MainInfo_InfoContainer__ww90q","Info":"MainInfo_Info__1JAg8","Details":"MainInfo_Details__Ub5Ek","Score":"MainInfo_Score__2CzSd"};